import React from 'react';
import {Icon} from "types/Icon";
import {SearchIcon} from "@heroicons/react/outline";
import {PlusIcon} from '@heroicons/react/solid';
import Button from "../Button";

type Props = {
    icon: Icon
    text: string
    hint?: string
    actionText: string
    actionIcon: Icon
    onActionClick?: () => any
}

function Empty({icon: Icon, text, hint, actionIcon: ActionIcon, actionText, onActionClick}: Props) {
    return (
        <div className="text-center">
            <Icon className="mx-auto h-10 w-10 text-gray-400"/>

            <h3 className="mt-2 text-sm font-medium text-gray-800">{text}</h3>
            {hint? <p className="mt-1 text-sm text-gray-500">{hint}</p> : null}

            {(onActionClick && actionText) ?
                <div className="mt-6">
                    <Button
                      color={Button.colors.PRIMARY}
                      icon={ActionIcon}
                      onClick={onActionClick}
                    >
                        {actionText}
                    </Button>
                </div>
            : null}
        </div>
    );
}

Empty.defaultProps = {
    icon: SearchIcon,
    actionText: "New",
    actionIcon: PlusIcon
}

export default Empty;